import { useEffect, useState } from 'react'
import { ImagePlaceholder } from '..'
import { useData } from '../../hooks/useData'
import { Image } from '../../shared/models/Image'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import './GalleryModal.scss'
import { Button, Dialog, DialogActions, DialogContent, Typography } from "@mui/material"
import { v4 } from "uuid"

type Props = {
  open: boolean
  currentImage?: Image
  onConfirm: (image: Image) => void
  onClose: () => void
}

export function GalleryModal(props: Props) {
  const { images } = useData()
  const { currentImage, onClose, onConfirm, open } = props
  const [image, setImage] = useState<Image | undefined>(currentImage)

  const handleSelection = (image: Image) => {
    setImage(image)
  }

  const handleConfirm = () => {
    if(image) {
      onConfirm(image)
      onClose()
    }
  }

  const handleClose = () => {
    setImage(undefined)
    onClose()
  }

  useEffect(() => {
    setImage(currentImage)
  }, [currentImage, open])

  return (
    <Dialog
      className="gallery-modal"
      fullWidth
      maxWidth="md"
      open={open}
      onClose={() => handleClose()}
      keepMounted={false}
    >
      <div className="dialog-header">
        <Typography variant="h5">Galeria</Typography>
      </div>

      <DialogContent>
        <div className="main-wrapper">
          <div className="description">
            <Typography variant="body1" fontSize="14px">
              Selecione uma das imagens da galeria para inserir no calendário.
            </Typography>
          </div>
          
          <div className="grid-container">
            <div className="grid">
              {
                images.map(opt => (
                  <Button
                    key={`opt-${opt.name}-${opt.title}`}
                    className={`thumb-button ${image?.filename === opt.filename ? 'selected' : ''}`}
                    onClick={() => handleSelection(opt)}
                  >
                    <LazyLoadImage
                      className="thumbnail"
                      src={`${process.env.PUBLIC_URL}/desenhos/thumb/${opt.filename}.jpg`}
                      alt={`Arte ${opt?.title || ''} feita por ${opt?.name || ''}`}
                      effect="opacity"
                      delayTime={2000}
                      placeholder={<ImagePlaceholder />}
                    />
                  </Button>
                ))
              }
            </div>
          </div>
        </div>

        <aside className="details-panel">
          <Typography className="title" variant="h6" component="h2">
            Detalhes
          </Typography>

          <div className="inner">
            <div className="preview">
              {
                !image ?
                  <ImagePlaceholder /> :
                  <img
                    src={`${process.env.PUBLIC_URL}/desenhos/${image.filename}.jpg`}
                    loading="lazy"
                    alt={`Arte ${image?.title || ''} feita por ${image?.name || ''}`}
                  />
              }
            </div>

            <hr />

            <ul className="author-data">
              <li>
                <span>Título:</span>
                <span>{ image?.title.toLowerCase() || '-' }</span>
              </li>
              <li>
                <span>Autor: </span>
                <span>{ image?.name || '-' }</span>
              </li>
              <li>
                <span>Idade: </span>
                <span>{ image?.age || '-' }</span>
              </li>
              <li>
                <span>Hiragana: </span>
                <span>{ image?.hiragana || '-' }</span>
              </li>
              <li>
                <span>Escola: </span>
                <span>{ image?.school || '-' }</span>
              </li>
              <li>
                <span>Cidade: </span>
                <span>{ image?.city } - { image?.uf }</span>
              </li>
            </ul>
          </div>
        </aside>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" color="error" onClick={() => handleClose()}>Cancelar</Button>
        <Button variant="contained" disabled={!image} onClick={() => handleConfirm()}>Confirmar</Button>
      </DialogActions>
    </Dialog>
  )
}